import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import {
  getImportedFileData,
  getTopThreeHistoryFileData,
  getProcessedData,
  getScenarioList,
  AllOtherFilesScenario,
} from "../../Api";

// Import components
import { useNavigate } from "react-router-dom";
import PreviewTable from "./components/PreviewTable";
import AddScenarioModal from "./components/AddScenarioModal";
import ViewFilesModal from "./components/ViewFilesModal";
import Swal from "sweetalert2";
import "./DataProcessing.css";
import TabContent from "./components/TabContent";

const tabsData = [
  "OFAC",
  "PEP",
  "UKSanctions",
  "NONSDN",
  "Grey List",
  "White List",
];

const DataProcessing = () => {
  const navigate = useNavigate();
  const [selectedTab] = useState(0);
  const [rows, setRows] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("Current");
  const [modalFile, setModalFile] = useState([]);
  const [modalScenario, setModalScenario] = useState([]);
  const [showPreviewTable, setShowPreviewTable] = useState(false);
  const [previewFileName, setPreviewFileName] = useState("");
  const [modalSearchTerm, setModalSearchTerm] = useState("");
  const [scenarioSearch, setScenarioSearch] = useState("");
  const [modalPreviewTableData, setModalPreviewTableData] = useState([]);
  const [showViewData, setShowViewData] = useState(false);
  const [scenarioType, setScenarioType] = useState([]);
  const [selectedScenarioType, setSelectedScenarioType] = useState(null);
  const [scenarioList, setScenarioList] = useState([]);
  const [viewFilesModal, setViewFilesModal] = useState(false);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [processedData, setProcessedData] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);

  const [filterDataFromDropDowns, setFilterDataFromDropDowns] = useState([]);

  const handleChildData = (value) => {
    setFilterDataFromDropDowns(value);
  };
  // Files list pagination state
  const [modalItemsPerPage] = useState(5);
  const [itemsPerPage] = useState(10);

  // Selected file details state
  const [modalSelectedFile, setModalSelectedFile] = useState(null);

  // User feedback state
  const [importedFiles, setImportedFiles] = useState([]);
  const [historyFiles, setHistoryFiles] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  // Add function to get file type based on selected tab
  const getFileType = () => {
    const tab = tabsData[selectedTab];
    switch (tab) {
      case "OFAC":
        return "OFAC_SDN";
      case "UKSanctions":
        return "UK_Sanctions";
      case "NONSDN":
        return "OFAC_NON_SDN";
      case "PEP":
        return "PEP";
      case "Watch List":
        return "WATCH_LIST";
      case "White List":
        return "WHITE_LIST";
      case "Negative Cases":
        return "NC";
      case "PC-LFM":
        return "PC-LFM";
      default:
        return "";
    }
  };

  // Add useEffect to fetch files when modal type changes - For Add Scenario Modal
  useEffect(() => {
    const fetchFiles = async () => {
      const bankCode = localStorage.getItem("bank_code");
      const fileType = selectedFileType
        ? selectedFileType.file_type
        : getFileType();

      if (modalType === "Current" && selectedFileType) {
        try {
          Swal.fire({
            html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
            showConfirmButton: false,
            heightAuto: false,
            customClass: { popup: "loader-swal" },
            allowOutsideClick: false,
          });
          const response = await getImportedFileData({
            file_type: fileType,
            bank_code: bankCode,
            page: 1,
            pageSize: 10,
          });
          Swal.close();
          console.log("Current files response:", response);
          if (
            response.status === "S" &&
            response.result_info &&
            response.result_info.length > 0
          ) {
            setImportedFiles(response.result_info);
            setModalFile([response.result_info[0].file_name]);
          } else {
            setImportedFiles([]);
            setModalFile([]);
            if (response.status === "E") {
              Swal.fire({
                icon: "warning",
                text:
                  response.message || "No files found for the current type.",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          }
        } catch (error) {
          console.error("Error fetching current files:", error);
          setImportedFiles([]);
          setModalFile([]);
          Swal.fire({
            icon: "error",
            text: "Failed to fetch current files",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } else if (modalType === "History" && selectedFileType) {
        try {
          Swal.fire({
            html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
            showConfirmButton: false,
            heightAuto: false,
            customClass: { popup: "loader-swal" },
            allowOutsideClick: false,
          });
          const response = await getTopThreeHistoryFileData({
            file_type: fileType,
            bank_code: bankCode,
          });
          Swal.close();
          console.log("History files response:", response);
          if (
            response.status === "S" &&
            response.result_info &&
            response.result_info.length > 0
          ) {
            setHistoryFiles(response.result_info);
            setModalFile([]);
          } else {
            setHistoryFiles([]);
            setModalFile([]);
            if (response.status === "E") {
              Swal.fire({
                icon: "warning",
                text: response.message || "No history files found.",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          }
        } catch (error) {
          console.error("Error fetching history files:", error);
          setHistoryFiles([]);
          setModalFile([]);
          Swal.fire({
            icon: "error",
            text: "Failed to fetch history files",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } else {
        // Clear files when no file type is selected
        setImportedFiles([]);
        setHistoryFiles([]);
        setModalFile([]);
      }
    };

    fetchFiles();
  }, [modalType, selectedFileType]);

  useEffect(() => {
    if (modalOpen) {
      setScenarioType([]);
      setSelectedScenarioType(null);
      setScenarioList([]);
      setModalScenario([]);
    }
  }, [modalOpen]);

  // Remove scenario type fetching from file selection and modal type change logic
  const handleModalTypeChange = (e) => {
    const value = e.target.value;
    setModalType(value);
    setModalFile([]);
    setScenarioType([]);
    setSelectedScenarioType(null);
    setScenarioList([]);
    setModalScenario([]);
    if (value === "Current" && importedFiles.length > 0) {
      // Auto-select the generated filename
      const fileName = importedFiles[0].file_name;
      setModalFile([fileName]);
    }
  };

  const handleFileChange = async (fileName) => {
    setModalFile([fileName]);
    // Reset scenario related states when file changes
    if (modalType === "History") {
      setScenarioType([]);
      setSelectedScenarioType(null);
      setScenarioList([]);
      setModalScenario([]);
    }
  };
  // Fix handleDeleteRow operator precedence
  const handleDeleteRow = (ind) => {
    setRows((prev) => {
      let newRows = { ...prev };
      newRows =
        (newRows?.length > 0 &&
          newRows.filter((row, index) => index !== ind)) ||
        [];
      return newRows;
    });
  };

  const handleOpenModal = () => {
    setModalOpen(true);
    setModalType("");
    setModalFile([]);
    setModalScenario([]);
    setSelectedScenarioType(null);
    setScenarioList([]);
    setSelectedFileType(null);
  };
  const handleCloseModal = () => setModalOpen(false);

  const handleSaveCombination = (data) => {
    const newId = Date.now();
    let scenarioValue;

    // Handle scenario value based on scenario type
    if (data.selectedScenarioType?.scenario_type === "Positive") {
      scenarioValue = ["Positive"];
    } else if (data.selectedScenarioType?.scenario_type === "Negative") {
      scenarioValue = ["Negative"];
    } else {
      scenarioValue = data.scenario;
    }

    const newRow = {
      id: newId,
      type: data.modalType,
      fileName: data.modalFile,
      scenario: scenarioValue,
      file_type: data.selectedFileType
        ? data.selectedFileType.file_type
        : getFileType(),
      scenario_type: data.selectedScenarioType?.scenario_type,
    };


    setRows((prev) => {
      return [...prev, newRow];
    });

    handleCloseModal();
  };

  // Fetch scenario type based on file selection
  const handleScenarioTypeChange = (selectedType) => {
    if (selectedType) {
      setSelectedScenarioType(selectedType);
      fetchScenarioList(selectedType.scenario_type);
    } else {
      setSelectedScenarioType(null);
      setScenarioList([]);
    }
    setModalScenario([]); // Reset scenario on type change
  };

  const fetchScenarioList = async (type) => {
    const fileType = selectedFileType
      ? selectedFileType.file_type
      : getFileType();
    const fileName = modalFile[0];
    const bankCode = localStorage.getItem("bank_code");

    try {
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });

      const response = await getScenarioList({
        file_type: fileType,
        file_name: fileName,
        bank_code: bankCode,
        scenario_type: type,
        correl_id: localStorage.getItem("correl_id") || "",
      });

      Swal.close();

      if (response.status === "S") {
        setScenarioList(response.result_info);
      } else {
        setScenarioList([]);
        Swal.fire({
          icon: "warning",
          text: response.message || "No scenarios found.",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.close();
      setScenarioList([]);
      Swal.fire({
        icon: "error",
        text: "Failed to fetch scenarios",
        showConfirmButton: false,
      });
    }
  };
  // Click on Submit this api triggered
  const handleSubmit = async () => {
    const rowsForProcessing = rows || [];
    if (rowsForProcessing.length === 0) {
      Swal.fire({
        icon: "warning",
        text: "Please add a combination to process.",
      });
      return;
    }
    // Reset preview table state when starting new process
    setShowPreviewTable(false);
    setModalPreviewTableData([]);
    setIsProcessing(true); // Set processing state to true
    try {
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });

      const bankCode = localStorage.getItem("bank_code");
      const correlId = localStorage.getItem("correl_id");
      let response;
      const payload = {
        bank_code: bankCode,
        correl_id: correlId,
        file_details: rowsForProcessing.map((row) => ({
          file_name: row.fileName[0],
          file_type: row.file_type,
          scenario: row.scenario,
          current_history: row.type,
        })),
      };
      response = await AllOtherFilesScenario(payload);
      Swal.close();

      if (response && response.status === "S") {
        Swal.fire({
          icon: "success",
          text: response.message,
        });
        setProcessedData(response.result_info);
        setShowViewData(true);
      } else {
        if (
          response.status === "F" &&
          (response.message === "Unauthorized - Missing token" ||
            response.message === "Unauthorized - Invalid token")
        ) {
          Swal.fire({
            text: "Please login with your credentials",
            icon: "warning",
            showConfirmButton: false,
            timer: 3000,
          });
          localStorage.clear();
          navigate("/login");
        } else {
          Swal.fire({
            icon: "error",
            text: response.message || "Processing failed.",
          });
        }
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        text: "An unexpected error occurred.",
      });
    } finally {
      setIsProcessing(false); // Reset processing state
    }
  };

  const handleViewData = async () => {
    setIsPreviewLoading(true);
    setShowPreviewTable(true);
    // Fetch data to display in the preview table
    await fetchProcessedData();
    setIsPreviewLoading(false);
  };

  const handleModalViewFile = (file) => {
    setModalSelectedFile(file);
  };

  const fetchProcessedData = async () => {
    console.log("fetchProcessedData called with processedData:", processedData); // Debug log
    if (!processedData?.processed_id) {
      console.log("No processed data available"); // Debug log
      return;
    }

    // Get file type from processed data or fallback to the first row's file type
    let fileType = processedData.file_type;
    if (!fileType && rows && rows.length > 0) {
      fileType = rows[0].file_type;
      console.log("Using file type from first row:", fileType); // Debug log
    }

    if (!fileType) {
      console.log("No file type available in processed data or rows"); // Debug log
      console.log("Processed data structure:", processedData); // Debug log
      console.log("Rows structure:", rows); // Debug log
      Swal.fire({
        icon: "error",
        text: "File type information is missing. Please try processing again.",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    setIsPreviewLoading(true);
    try {
      const params = {
        processed_id: processedData.processed_id,
        bank_code: localStorage.getItem("bank_code"),
        correl_id: localStorage.getItem("correl_id"),
        file_type: fileType,
        page: 1,
        pageSize: 10000, // Large page size to get all data
        output_filename: "", // Empty string as per your payload
        scenarios: [], // Empty array as per your payload
      };

      console.log("Fetching processed data with params:", params); // Debug log

      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });

      const response = await getProcessedData(params);
      console.log("API Response:", response); // Debug log
      Swal.close();

      if (response?.status === "S" && response?.result_info) {
        setModalPreviewTableData(response.result_info);
      } else if (
        response.status === "F" &&
        (response.message === "Unauthorized - Missing token" ||
          response.message === "Unauthorized - Invalid token")
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        });
        localStorage.clear();
        navigate("/login");
      } else {
        setModalPreviewTableData([]);
      }
    } catch (error) {
      Swal.close();
      setModalPreviewTableData([]);
      Swal.fire({
        icon: "error",
        text: "Error fetching processed data.",
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setIsPreviewLoading(false);
    }
  };

  // helper function to handle modal search term change
  const handleModalSearchChange = (value) => {
    setModalSearchTerm(value);
  };

  const getButtonText = () => {
    return processedData ? "View Data" : "Submit";
  };

  function csvEscape(value) {
    if (value === null || value === undefined) return "";
    const s = String(value);
    return /[\",\\r\\n]/.test(s) ? `"${s.replace(/\"/g, '""')}"` : s;
  }
  // Handle export functionality
  const handleExport = async () => {
    if (!processedData?.processed_id) {
      Swal.fire({
        icon: "warning",
        text: "No data available for export.",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    try {
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        text: "Exporting all data...",
        showConfirmButton: false,
        heightAuto: false,
        allowOutsideClick: false,
        customClass: { popup: "loader-swal" },
      });

      // Fetch all data without pagination
      // const allData = await fetchAllProcessedData();

      Swal.close();

      if (filterDataFromDropDowns && filterDataFromDropDowns.length > 0) {
        // Create CSV content from all the data
        const headers = [
          "ENT NUM",
          "Name",
          "Processed Name",
          "Pre Processed Name",
          "Scenario",
        ];
        // const csvContent = [
        //   headers.join(','),
        //   ...allData.map(row => [
        //     row.unique_id || '',
        //     row.original_name || '',
        //     row.processed_name || '',
        //     row.pre_processed_name || '',
        //     row.scenario || ''
        //   ].join(','))
        // ].join('\n');
        // Build rows
        const rows = filterDataFromDropDowns.map((row) => [
          row.unique_id || "",
          row.original_name || "",
          row.processed_name || "",
          row.pre_processed_name || "",
          row.scenario || "",
        ]);

        // CSV escape + join
        const csvLines = [
          headers.map(csvEscape).join(","),
          ...rows.map((r) => r.map(csvEscape).join(",")),
        ];

        // \uFEFF adds UTF‑8 BOM so Excel/Sheets detect encoding; \r\n improves Excel compatibility
        const csvContent = "\uFEFF" + csvLines.join("\r\n");

        // Create and download the CSV file
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `Preview_data_${Date.now()}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Swal.fire({
          icon: "success",
          text: `Successfully exported ${filterDataFromDropDowns.length} records!`,
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        Swal.fire({
          icon: "warning",
          text: "No data found to export.",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.close();
      console.error("Export error:", error);
      Swal.fire({
        icon: "error",
        text: "An error occurred during export.",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  // Function to fetch all processed data without pagination
  const fetchAllProcessedData = async () => {
    console.log("fetchAllProcessedData - processedData:", processedData); // Debug log
    console.log("fetchAllProcessedData - rows:", rows); // Debug log
    if (!processedData?.processed_id) return [];

    // Get file type from processed data or use the file type from the processed rows
    let fileType = processedData.file_type;
    if (!fileType && rows && rows.length > 0) {
      fileType = rows[0].file_type;
      console.log("Using file type from first row for export:", fileType);
    }

    if (!fileType) {
      console.log("No file type available for export");
      return [];
    }

    try {
      const bankCode = localStorage.getItem("bank_code");
      const correlId = localStorage.getItem("correl_id");

      const params = {
        processed_id: processedData.processed_id,
        bank_code: bankCode,
        correl_id: correlId,
        // Use the file type determined with fallback logic
        file_type: fileType,
        page: 1,
        pageSize: 999999, // Very large number to get all data
        output_filename: "", // Empty string as per your payload
        scenarios: [], // Empty array as per your payload
      };

      console.log("Export API params:", params); // Debug log

      // Fetch all data with a very large pageSize to get everything
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });
      const response = await getProcessedData(params);
      Swal.close();
      if (response?.status === "S" && response?.result_info) {
        return response.result_info;
      } else if (
        response.status === "F" &&
        (response.message === "Unauthorized - Missing token" ||
          response.message === "Unauthorized - Invalid token")
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        });
        localStorage.clear();
        navigate("/login");
        return [];
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching all processed data:", error);
      return [];
    }
  };

  return (
    <div className="efficiency-page">
      <div className="page-container">
        <div className="d-flex justify-content-end align-items-center mb-3">
          {/* <div className="justify-content-start">
            <button
              className="anchor-button"
              onClick={() => setViewFilesModal(true)}
            >
              View Files
            </button>
          </div> */}
          {!showViewData && (
            <div className="justify-content-end">
              <Button
                variant="contained"
                color="primary"
                style={{ backgroundColor: "var(--theme-color)", color: "#fff" }}
                onClick={handleOpenModal}
              >
                + Add New Scenario
              </Button>
            </div>
          )}
        </div>
        <div className="content-container">
          <div className="table-action-container">
            <TabContent
              rows={rows || []}
              setRows={setRows}
              processedData={processedData}
              onDelete={handleDeleteRow}
            />
            {!showPreviewTable && (
              <div className="button-container text-center">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (processedData) {
                      handleViewData();
                    } else {
                      handleSubmit();
                    }
                  }}
                  disabled={isProcessing || (rows || []).length === 0}
                >
                  {isProcessing ? "Processing..." : getButtonText()}
                </Button>
              </div>
            )}
          </div>
          {showPreviewTable && (
            <PreviewTable
              previewTableData={modalPreviewTableData}
              onExport={handleExport}
              loading={isPreviewLoading}
              fileType={
                processedData?.file_type ||
                (rows && rows.length > 0 ? rows[0].file_type : null)
              }
              handleChildData={handleChildData}
            />
          )}
        </div>
        {modalOpen && (
          <AddScenarioModal
            modalOpen={modalOpen}
            handleCloseModal={handleCloseModal}
            modalType={modalType}
            handleModalTypeChange={handleModalTypeChange}
            modalFile={modalFile}
            setModalFile={setModalFile}
            handleFileChange={handleFileChange}
            importedFiles={importedFiles}
            historyFiles={historyFiles}
            scenarioType={scenarioType}
            selectedScenarioType={selectedScenarioType}
            handleScenarioTypeChange={handleScenarioTypeChange}
            scenarioList={scenarioList}
            modalScenario={modalScenario}
            setModalScenario={setModalScenario}
            scenarioSearch={scenarioSearch}
            setScenarioSearch={setScenarioSearch}
            handleSaveCombination={handleSaveCombination}
            selectedFileType={selectedFileType}
            setSelectedFileType={setSelectedFileType}
          />
        )}
        {viewFilesModal && (
          <ViewFilesModal
            setViewFilesModal={setViewFilesModal}
            tabsData={tabsData}
            selectedTab={selectedTab}
            handleModalViewFile={handleModalViewFile}
            modalSelectedFile={modalSelectedFile}
            modalSearchTerm={modalSearchTerm}
            handleModalSearch={handleModalSearchChange}
            modalPreviewTableData={modalPreviewTableData}
          />
        )}
      </div>
    </div>
  );
};

export default DataProcessing;
